var datamodel_version = "9";
module.exports = datamodel_version;
console.log("Loading datamodel version: " + datamodel_version);
